<template>
    <dx-grid
        :url="url"
        :columns="columns"
        :title="title"
        :actions="actions"
        :beforeSetupGrid="beforeSetupGrid"
        ref="grid"
        :summaryOptions="{
            enabled: true,
            grouping: true,
            groupingColumns: ['date'],
            groupingSumColumns: [
                'date',
                'people',
                'amount',
                'creditCard',
                'cash',
                'zchurim',
                'nakeivas',
            ],
            columns: [
                'people',
                'amount',
                'creditCard',
                'cash',
                'zchurim',
                'nakeivas',
            ],
        }"
    ></dx-grid>
</template>

<script>
import { pluralize, sum, formatCurrency } from "../../utils/helpers.js";
import moment from "moment";

export default {
    data: () => ({
        title: "Kapures Totals",
        totals: [],
        isExporting: false,
        url: "",
        campaignName: "",
        campaigns: [],
        actions: [],

        columns: [
            {
                label: "Date",
                field: "date",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy",
                sortOrder: "desc",
                sortIndex: 0,
                groupIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },

            {
                label: "Site",
                field: "site",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "People",
                field: "people",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Zchurim",
                field: "zchurim",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Nakeivas",
                field: "nakeivas",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Amount",
                field: "amount",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Credit Card",
                field: "creditCard",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Cash",
                field: "cash",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    watch: {},
    async created() {},
    methods: {
        async beforeSetupGrid() {
            const campaigns = await this.getCampaigns();

            this.actions.push({
                text: "Select Term",
                type: "select",
                values: campaigns,
                value: this.campaignName,
                onSelected: this.onTermSelected,
            });

            this.url =
                "kapuresTotals?campaignName=" +
                encodeURIComponent(this.campaignName);
        },
        async getCampaigns() {
            const campaigns = await this.$http.get("api/Kapures/getCampaigns");

            this.campaigns = campaigns
                .map((c) => c.campaignName)
                .sort(function(a, b) {
                    if (a > b) {
                        return -1;
                    } else {
                        return 1;
                    }
                });
            this.campaignName = this.campaigns[0];

            return this.campaigns;
        },
        onTermSelected(value) {
            this.campaignName = value;

            this.url =
                "kapuresTotals?campaignName=" +
                encodeURIComponent(this.campaignName);

            this.$refs.grid.reloadDataSource(this.url);
        },
    },
};
</script>
<style>
.toggle-button {
    font-size: 15px;
    padding: 5px !important;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active {
    background-color: #dcdfe6;
}
.v-btn__content {
    color: unset;
}
</style>
